import { render, staticRenderFns } from "./NoRecords.vue?vue&type=template&id=ba67388e&"
import script from "./NoRecords.vue?vue&type=script&lang=ts&"
export * from "./NoRecords.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba67388e')) {
      api.createRecord('ba67388e', component.options)
    } else {
      api.reload('ba67388e', component.options)
    }
    module.hot.accept("./NoRecords.vue?vue&type=template&id=ba67388e&", function () {
      api.rerender('ba67388e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/src/components/NoRecords.vue"
export default component.exports